import React from "react";
import { THEME_GROUPS, PRESETS } from "@/lib/theme";

function Swatch({ item, value, onChange }: any) {
  const cur = value || item.def;
  return (
    <div className="flex items-center gap-3" data-testid={`theme-row-${item.k}`}>
      <input type="color" value={cur} onChange={(e) => onChange(e.target.value)} className="h-10 w-12 flex-none border border-neutral-200" data-testid={`theme-${item.k}-input`} />
      <div className="min-w-0 flex-1">
        <p className="text-xs leading-tight">{item.label}</p>
        <div className="flex items-center gap-2 mt-1">
          <input value={cur} onChange={(e) => /^#[0-9a-fA-F]{0,6}$/.test(e.target.value) && onChange(e.target.value)} className="w-20 border border-neutral-300 px-1.5 py-0.5 text-[11px] font-mono uppercase outline-none focus:border-neutral-900" data-testid={`theme-${item.k}-hex`} />
          {value && value.toLowerCase() !== item.def.toLowerCase() && <button type="button" onClick={() => onChange("")} className="text-[10px] underline text-neutral-500" data-testid={`theme-${item.k}-reset`}>reset</button>}
        </div>
      </div>
    </div>
  );
}

function Preview({ t }: { t: any }) {
  const c = (k: string) => t[k] || THEME_GROUPS.flatMap((g) => g.items).find((i) => i.k === k)!.def;
  return (
    <div className="border border-neutral-200 overflow-hidden text-[11px]" data-testid="theme-preview">
      <div className="text-center py-1.5 uppercase tracking-[0.18em] text-white" style={{ background: c("announcement") }}>Announcement bar</div>
      <div className="px-4 py-3 flex justify-between items-center" style={{ background: c("header_bg"), color: c("header_fg"), borderBottom: `1px solid ${c("border")}` }}><span className="font-wordmark">SOMNIO.CO</span><span className="uppercase tracking-[0.2em]">Menu</span></div>
      <div className="p-5 space-y-3" style={{ background: c("background"), color: c("foreground") }}>
        <p className="font-display text-xl">The Aurora Solitaire</p>
        <p style={{ color: c("price") }}>$2,450</p>
        <p style={{ color: c("soft_text") }}>Lab-grown diamond in 18k gold. <span style={{ color: c("primary") }} className="underline">Learn more</span></p>
        <div className="flex gap-2">{["5", "6", "7"].map((s, i) => <span key={s} className="h-7 w-7 grid place-items-center" style={i === 1 ? { background: c("selected"), color: "#fff" } : { border: `1px solid ${c("border")}` }}>{s}</span>)}</div>
        <div className="p-3" style={{ background: c("muted") }}>Soft panel</div>
        <div className="flex gap-2"><span className="px-4 py-2 uppercase tracking-[0.2em]" style={{ background: c("button_bg"), color: c("button_fg") }}>Add to bag</span><span className="px-4 py-2 uppercase tracking-[0.2em]" style={{ background: c("button_hover_bg"), color: c("button_hover_fg") }}>Hover</span></div>
      </div>
      <div className="px-4 py-3" style={{ background: c("footer_bg"), color: c("footer_fg") }}>© SOMNIO.CO P/L</div>
    </div>
  );
}

export function ThemeEditor({ theme, onChange }: { theme: any; onChange: (v: any) => void }) {
  const t = theme || {};
  return (
    <section className="bg-white border border-neutral-200 p-6 space-y-6" data-testid="theme-editor">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div><p className="eyebrow text-[10px] text-neutral-500">Theme colours</p><p className="text-xs text-neutral-600 mt-1">Pick a starting palette, then fine-tune any colour. Changes go live when you save.</p></div>
        <div className="flex flex-wrap gap-2" data-testid="theme-presets">
          {PRESETS.map((p) => (
            <button key={p.name} type="button" onClick={() => onChange({ ...p.theme })} className="border border-neutral-300 hover:border-neutral-900 px-3 py-1.5 text-[11px] uppercase tracking-wider transition-colors" data-testid={`theme-preset-${p.name.toLowerCase().replace(/\s+/g, "-")}`}>{p.name}</button>
          ))}
        </div>
      </div>
      <div className="grid lg:grid-cols-[1fr_300px] gap-8">
        <div className="space-y-6">
          {THEME_GROUPS.map((g) => (
            <div key={g.title}>
              <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-3">{g.title}</p>
              <div className="grid sm:grid-cols-2 gap-4">{g.items.map((i) => <Swatch key={i.k} item={i} value={t[i.k]} onChange={(v: string) => onChange({ ...t, [i.k]: v })} />)}</div>
            </div>
          ))}
        </div>
        <Preview t={t} />
      </div>
    </section>
  );
}
